import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Home } from './pages/Home';
import { Campers } from './pages/Campers';
import { CamperPage } from './pages/CamperPage';
import { GiftCard } from './pages/GiftCard';
import { RentalConditions } from './pages/RentalConditions';
import { ScrollToTop } from './components/ScrollToTop';
import { LegalNotice } from './pages/LegalNotice';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { CookiesPolicy } from './pages/CookiesPolicy';
import { Footer } from './components/Footer';
import { Blog } from './pages/Blog';
import { BlogPost } from './pages/Blog/BlogPost';
import Resources from './pages/Resources';
import TripPlanner from './pages/TripPlanner';
import TripRecommendationsPage from './pages/TripRecommendationsPage';
import TripRouteDetail from './pages/TripRouteDetail';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/campers" element={<Campers />} />
        <Route path="/campers/:slug" element={<CamperPage />} />
        <Route path="/regala" element={<GiftCard />} />
        <Route path="/condiciones-alquiler" element={<RentalConditions />} />
        <Route path="/aviso-legal" element={<LegalNotice />} />
        <Route path="/politica-privacidad" element={<PrivacyPolicy />} />
        <Route path="/politica-cookies" element={<CookiesPolicy />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/resources/trip-planner" element={<TripPlanner />} />
        <Route path="/resources/trip-planner/recommendations" element={<TripRecommendationsPage />} />
        <Route path="/resources/trip-planner/route/:routeId" element={<TripRouteDetail />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
